export enum EGoalPublicStatus {
   Shared = 1,
   Private = 2,
   Public = 3
}
